import type { District } from '@bid/shared-types';

export interface DistrictInfo {
  name: District;
  description: string;
  characteristics: string[];
  controllingFactions: string[];
  typicalLocations: string[];
  wealth: 'Poor' | 'Moderate' | 'Wealthy' | 'Elite';
  security: 'Low' | 'Moderate' | 'High' | 'Extreme';
}

export const districts: DistrictInfo[] = [
  {
    name: 'Charhollow',
    description: 'A crowded, working-class district filled with tenements',
    characteristics: ['Overcrowded', 'Working class', 'Tenements'],
    controllingFactions: ['The Gray Cloaks', 'The Billhooks'],
    typicalLocations: ['Tenements', 'Factories', 'Pubs'],
    wealth: 'Poor',
    security: 'Low',
  },
  {
    name: 'Coalridge',
    description: 'An industrial area with factories and smokestacks',
    characteristics: ['Industrial', 'Polluted', 'Blue collar'],
    controllingFactions: ['The Billhooks'],
    typicalLocations: ['Factories', 'Warehouses', 'Worker housing'],
    wealth: 'Poor',
    security: 'Moderate',
  },
  {
    name: "Crow's Foot",
    description: 'A rough, gang-controlled neighborhood',
    characteristics: ['Gang territory', 'Criminal', 'Dangerous'],
    controllingFactions: ['The Lampblacks', 'The Red Sashes', 'The Crows'],
    typicalLocations: ['Taverns', 'Dens', 'Gang hideouts'],
    wealth: 'Moderate',
    security: 'Low',
  },
  {
    name: 'The Docks',
    description: 'A busy port area with warehouses and ships',
    characteristics: ['Port', 'Trade', 'Smuggling'],
    controllingFactions: ['The Lampblacks', 'The Gray Cloaks'],
    typicalLocations: ['Warehouses', 'Piers', 'Sailor bars'],
    wealth: 'Moderate',
    security: 'Moderate',
  },
  {
    name: 'Dunslough',
    description: 'A poor district by the river',
    characteristics: ['Poverty', 'Riverfront', 'Desperate'],
    controllingFactions: [],
    typicalLocations: ['Shanties', 'Squats', 'River shacks'],
    wealth: 'Poor',
    security: 'Low',
  },
  {
    name: 'Nightmarket',
    description: 'A commercial district open all night',
    characteristics: ['Commerce', 'Always open', 'Diverse'],
    controllingFactions: [],
    typicalLocations: ['Markets', 'Shops', 'Restaurants'],
    wealth: 'Moderate',
    security: 'Moderate',
  },
  {
    name: 'Six Towers',
    description: 'An affluent neighborhood with grand spires',
    characteristics: ['Wealthy', 'Aristocratic', 'Spires'],
    controllingFactions: ['The Hive', 'The Unseen'],
    typicalLocations: ['Mansions', 'Clubs', 'Fine establishments'],
    wealth: 'Wealthy',
    security: 'High',
  },
  {
    name: 'Silkshore',
    description: 'A district of vice and entertainment',
    characteristics: ['Vice', 'Entertainment', 'Pleasure houses'],
    controllingFactions: [],
    typicalLocations: ['Theaters', 'Bath houses', 'Taverns'],
    wealth: 'Moderate',
    security: 'Moderate',
  },
  {
    name: 'Whitecrown',
    description: 'The wealthy district with government buildings',
    characteristics: ['Government', 'Elite', 'Law'],
    controllingFactions: ['City Council', 'The Inspectors'],
    typicalLocations: ['Government buildings', 'Banks', 'Courts'],
    wealth: 'Elite',
    security: 'Extreme',
  },
];
